import styled from "styled-components/macro";

export const $HeadingsWrapper = styled.div`
  align-items: center;
  padding: 2rem 0 1rem 0.5rem;

  @media screen and (${({ theme }) => theme.BreakpointPhoneDown}) {
    flex-direction: column;

    > * {
      width: 100%;
    }

    h2 {
      font-size: ${({ theme }) => theme.FontSizeMobileH2};
      line-height: ${({ theme }) => theme.FontLineHeightMobileH2};
    }

    h3 {
      font-size: ${({ theme }) => theme.FontSizeMobileH3};
      line-height: ${({ theme }) => theme.FontLineHeightMobileH3};
    }
  }
`;
